<template>
    <div>
        {{ $t('notification.userPasswordChanged', { 
            actor: $_.get(activity, 'actorUser.name'), 
            userName: $_.get(activity, 'payload.userName')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserPasswordChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

